import React from "react";
import { useNavigate } from "react-router-dom";
import { useGetClaimsPaginatedQuery } from "../../api/claimsApi";
import { AddButton } from "../../components/common/AddButton";
import PageTitle from "../../components/common/PageTitle";
import { ClaimsIcon } from "../../components/common/pageIcons";
import { DEFAULT_DATA_TABLE_PAGE_SIZE } from "../../constants/dataTable";
import ClaimsTable from "./components/ClaimsTable";
import PageLayout from "../../components/layout/PageLayout";
import { useDataTablePagination } from "../../hooks/useDataTablePagination";

const ClaimsPage: React.FC = () => {
  const navigate = useNavigate();
  const {
    items: claims,
    isLoading,
    isLoadingRows,
    isLoadingMore,
    totalCount,
    hasNextPage,
    handleSearchChange,
    handleLoadMore,
  } = useDataTablePagination(
    useGetClaimsPaginatedQuery,
    DEFAULT_DATA_TABLE_PAGE_SIZE
  );

  return (
    <PageLayout>
      <PageTitle
        title="Claims Board"
        icon={<ClaimsIcon />}
        titleVariant="h4"
        subtitle="Manage and track all claims"
        actions={
          <AddButton onClick={() => navigate("/claims/create")}>Add Claim</AddButton>
        }
      />

      <ClaimsTable
        claims={claims}
        isLoading={isLoading}
        totalCount={totalCount}
        hasNextPage={hasNextPage}
        isLoadingMore={isLoadingMore}
        isLoadingRows={isLoadingRows}
        onLoadMore={handleLoadMore}
        enableSearch={true}
        onSearchChange={handleSearchChange}
      />
    </PageLayout>
  );
};

export default ClaimsPage;
